// Theme-only bridge for the old category URL. A permanent server redirect belongs to launch.
(() => {
  if (window.Shopify?.designMode) return;
  const source = document.querySelector('[data-category-forward]');
  if (!source) return;
  const target = new URL(source.dataset.categoryForward, location.origin);
  if (target.origin !== location.origin || target.pathname === location.pathname) return;
  // Retain preview credentials and the locale already supplied by the Shopify page URL.
  target.search = location.search;
  target.hash = location.hash;
  const link = source.querySelector('a');
  if (link) link.href = target.href;
  location.replace(target.href);
})();
